/**
 * Outlets Page Index
 */

export { default as OutletsPage } from './OutletsPage';
